import { render, staticRenderFns } from "./AlarmTable.vue?vue&type=template&id=edc6b6da"
import script from "./AlarmTable.vue?vue&type=script&lang=ts"
export * from "./AlarmTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports